import { render } from "./arki-work-component.vue?vue&type=template&id=c8f5927c"
import script from "./arki-work-component.vue?vue&type=script&setup=true&lang=js"
export * from "./arki-work-component.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/arki/views/request/project/arki-work-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8f5927c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8f5927c', __exports__)) {
    api.reload('c8f5927c', __exports__)
  }
  
  module.hot.accept("./arki-work-component.vue?vue&type=template&id=c8f5927c", () => {
    api.rerender('c8f5927c', render)
  })

}


export default __exports__